export const PARENT_CACHE_KEY = 'root';

export const getFormErrorMessage = (error, t) => {
  if (typeof error === 'string') {
    return error;
  }
  if (error?.name?.[0]) {
    return error.name[0];
  }
  return t('something-went-wrong');
};

export const normalizeParentId = (parentId) => {
  if (parentId == null || parentId === '' || parentId === PARENT_CACHE_KEY) {
    return null;
  }

  return parentId;
};

export const getReportsDesktopPath = (parentId) => {
  const normalized = normalizeParentId(parentId);
  return normalized ? `/reports/folder/${normalized}` : '/reports/custom-reports';
};

export const isDescendantInCache = (ancestorId, targetId, cache) => {
  if (!ancestorId || !targetId || ancestorId === targetId) {
    return ancestorId === targetId;
  }

  const children = (cache[ancestorId] || []).filter((item) => item.type === 'folder');
  return children.some(
    (child) => child.id === targetId || isDescendantInCache(child.id, targetId, cache)
  );
};

export const isInvalidMoveTarget = (itemId, itemType, targetParentId, itemsCache) => {
  if (itemType !== 'folder' || !targetParentId) {
    return false;
  }

  return itemId === targetParentId || isDescendantInCache(itemId, targetParentId, itemsCache);
};
